import { render, staticRenderFns } from "./tasksTodayGoods.vue?vue&type=template&id=80cac652&"
import script from "./tasksTodayGoods.vue?vue&type=script&lang=js&"
export * from "./tasksTodayGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports